import { FC } from 'react';
import { useIntl } from 'react-intl';
import { CalculatorHeading } from '@components/common/CalculatorHeading/CalculatorHeading';
import { CalculatorText } from '@components/common/CalculatorText/CalculatorText';
import { FormSelect } from '@components/common/FormSelect/FormSelect';
import { CalculatorSelectProps } from './types';

export const CalculatorSelect: FC<CalculatorSelectProps> = ({
  name,
  textKey,
  titleKey,
  rules,
  className,
  options,
  selectProps,
  placeholderKey,
  shouldShowAdornment = false,
  onChangeEffect,
}) => {
  const intl = useIntl();

  return (
    <div className={className}>
      <CalculatorHeading labelKey={titleKey} />
      {textKey && <CalculatorText labelKey={textKey} />}
      <FormSelect
        name={name}
        rules={rules}
        className={'mt-2'}
        options={options}
        shouldShowAdornment={shouldShowAdornment}
        selectProps={selectProps}
        selectInputProps={{
          placeholder: intl.formatMessage({ id: placeholderKey }),
        }}
        onChangeEffect={onChangeEffect}
      />
    </div>
  );
};
